<div class="text-label">
  {{ text() }}
</div>